import '../assets/Input.css';
import { h, defineComponent, useCssVars, unref, ref, computed, openBlock, createElementBlock, createVNode, createElementVNode, toDisplayString, withDirectives, vModelDynamic, createBlock, createCommentVNode } from 'vue';
import { _ as _sfc_main$1 } from './Tooltip.vue_vue_type_style_index_0_lang.DaDt-PuW.js';
import { e as appendPx } from './useStore.DAPvMbcE.js';

const icon = (props, context) => {
    const xmlns = "http://www.w3.org/2000/svg";
    const svgCode = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 21" fill="currentColor">
  <path fill-rule="evenodd" d="M6.843 3.211a8.25 8.25 0 116.314 15.244A8.25 8.25 0 016.843 3.211zM10 4.083a6.75 6.75 0 100 13.5 6.75 6.75 0 000-13.5zM7.803 8.636a.75.75 0 011.06 0L10 9.772l1.136-1.136a.75.75 0 011.061 1.06l-1.136 1.137 1.136 1.136a.75.75 0 01-1.06 1.061L10 11.894 8.864 13.03a.75.75 0 11-1.061-1.06l1.136-1.137-1.136-1.136a.75.75 0 010-1.061z" clip-rule="evenodd"/>
</svg>
`;
    
    const svgRoot = new DOMParser().parseFromString(svgCode, 'image/svg+xml').firstChild;
    
    if (props.title) {
      const title = document.createElementNS(xmlns, 'title');
      title.textContent = props.title;
      svgRoot.appendChild(title);
    }

    const svgAttributes = Array
      .from(svgRoot?.attributes ?? [])
      .reduce((acc, curr) => ({
        ...acc,
        [curr.name]: curr.value
      }));

    return h(
      'svg',
      {
        ...svgAttributes,
        ...context.attrs,
        role: 'img',
        innerHTML: svgRoot.innerHTML
      },
    );
  };

const _hoisted_1 = {
  class: "thn--tool-input",
  ref: "rootRef"
};
const _hoisted_2 = ["for"];
const _hoisted_3 = { class: "relative w-full" };
const _hoisted_4 = ["required", "disabled", "type", "name", "id", "error", "placeholder", "aria-label"];
const paddingX = 10;
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Input",
  props: {
    placeholder: { default: "" },
    type: {},
    errorMessage: { default: "" },
    required: { type: Boolean },
    disabled: { type: Boolean },
    modelValue: {},
    id: {}
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
    useCssVars((_ctx) => ({
      "d5825cb0": unref(appendPx)(paddingX)
    }));
    const props = __props;
    const emit = __emit;
    const inputRef = ref();
    const errorTooltipRef = ref();
    const inputValue = computed({
      get: () => props.modelValue,
      set: (value) => {
        emit("update:modelValue", value);
      }
    });
    function hideError() {
      errorTooltipRef.value.hide();
    }
    function showError() {
      const {
        top,
        left
      } = inputRef.value?.getBoundingClientRect() || {};
      errorTooltipRef.value.show(props.errorMessage, {
        top,
        left: left + paddingX
      });
    }
    function validate() {
      const isValid = inputRef.value.validity.valid;
      if (!isValid) {
        showError();
      }
      return isValid;
    }
    function clear() {
      inputRef.value.value = "";
    }
    __expose({
      clear,
      validate
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        createVNode(_sfc_main$1, {
          ref_key: "errorTooltipRef",
          ref: errorTooltipRef,
          "auto-hide": 3e3
        }, null, 512),
        createElementVNode("label", {
          class: "sr-only",
          for: _ctx.id
        }, toDisplayString(_ctx.placeholder), 9, _hoisted_2),
        createElementVNode("div", _hoisted_3, [
          withDirectives(createElementVNode("input", {
            role: "textbox",
            class: "thn--tool-input__input",
            ref_key: "inputRef",
            ref: inputRef,
            dir: "auto",
            required: _ctx.required,
            disabled: _ctx.disabled,
            type: _ctx.type || "email",
            name: _ctx.type || "email",
            id: _ctx.id,
            error: errorTooltipRef.value?.showing,
            placeholder: _ctx.placeholder,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => inputValue.value = $event),
            onMousedown: hideError,
            "aria-label": _ctx.placeholder,
            "aria-live": "assertive"
          }, null, 40, _hoisted_4), [
            [vModelDynamic, inputValue.value]
          ]),
          errorTooltipRef.value?.showing ? (openBlock(), createBlock(unref(icon), {
            key: 0,
            class: "absolute right-2 top-1/2 transform -translate-y-1/2 text-danger-500 w-5 h-5 pointer-events-none"
          })) : createCommentVNode("", true)
        ])
      ], 512);
    };
  }
});

export { _sfc_main as _ };
//# sourceMappingURL=Input.vue_vue_type_style_index_0_lang.DnSVy8w3.js.map
